import { rankingItems } from '@/mocks/home';

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-5xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-2">吃瓜热榜</h2>
          <p className="text-sm text-foreground-500">实时追踪全网最热话题，为你精选今日必看内容</p>
        </div>

        <div className="space-y-3">
          {rankingItems.map((item) => (
            <a
              key={item.rank}
              href="#ranking"
              className="flex items-center gap-4 p-4 rounded-xl bg-background-100 hover:bg-background-200 transition-colors cursor-pointer group"
            >
              <div className={`w-10 h-10 rounded-xl flex items-center justify-center font-heading text-lg flex-shrink-0 ${
                item.rank <= 3 ? 'bg-primary-500 text-background-50' : 'bg-background-200 text-foreground-500'
              }`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm md:text-base font-medium text-foreground-900 truncate group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
              </div>
              <span className={`px-2 py-0.5 rounded-md text-xs font-medium text-background-50 whitespace-nowrap flex-shrink-0 ${item.tagColor}`}>
                {item.tag}
              </span>
              <span className="text-xs text-foreground-400 whitespace-nowrap flex-shrink-0 hidden sm:inline">
                <i className="ri-fire-line mr-1 text-accent-500"></i>{item.hot}
              </span>
            </a>
          ))}
        </div>

        <div className="text-center mt-8">
          <a href="#ranking" className="inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium cursor-pointer">
            查看完整榜单 <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}